import { create } from "zustand";
import { persist } from "zustand/middleware";
import { FINAL_DRAFT_SURVEY_FORM_PERSIST_KEY } from "../constants";

interface FinalDraftSurveyFormState {
  operationId: string | null;
  total: string;
  setValues: (operationId: string, total: string) => void;
  reset: () => void;
}

export const useFinalDraftSurveyFormStore = create<FinalDraftSurveyFormState>()(
  persist(
    (set) => ({
      operationId: null,
      total: "",
      setValues: (operationId, total) => set({ operationId, total }),
      reset: () => set({ operationId: null, total: "" }),
    }),
    { name: FINAL_DRAFT_SURVEY_FORM_PERSIST_KEY },
  ),
);
